// Whether the starter pack offer dialog (GLOSSARY.md) has been shown, per
// user and starter-pack product: another account on the same device, or a
// future starter pack, still gets its own announcement. Remembered in
// localStorage; when storage is unavailable or throws, remembered for this
// page load only — the dialog then shows at most once per session.

export function starterPackOfferShownKey(
  userId: number,
  productId: number,
): string {
  return `shop:starter-pack-offer-shown:${userId}:${productId}`
}

export interface StarterPackOfferMemory {
  hasShown: (userId: number, productId: number) => boolean
  remember: (userId: number, productId: number) => void
}

// One per page load: the session fallback lives as long as Shop does.
export function createStarterPackOfferMemory(): StarterPackOfferMemory {
  const session = new Set<string>()
  return {
    hasShown: (userId, productId) => {
      const key = starterPackOfferShownKey(userId, productId)
      if (session.has(key)) return true
      try {
        return window.localStorage.getItem(key) !== null
      } catch {
        return false
      }
    },
    remember: (userId, productId) => {
      const key = starterPackOfferShownKey(userId, productId)
      session.add(key)
      try {
        window.localStorage.setItem(key, '1')
      } catch {
        // Storage unavailable: the session set above remembers it.
      }
    },
  }
}
